import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Analysis = () => {
    return (
        <div className="analysis">
            <FullWrapper isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="analysis-main">
                        <div className="analysis-text">
                            <div>
                                Для анализа выбираем 6 прямых конкурентов, у которых высокий процент
                                видимости в Яндексе и Google:
                            </div>
                            <img
                                alt="Для анализа выбираем 6 прямых конкурентов, у которых высокий процент видимости в Яндексе и Google"
                                src="/images/pic/seo-fintech/analysis-img.png"
                                className="analysis-img"
                                loading="lazy"
                            />
                        </div>

                        <div className="analysis-table">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Сайт</th>
                                        <th>Видимость в Я %</th>
                                        <th>Видимость в G %</th>
                                    </tr>
                                    <tr>
                                        <td>sberbank.ru</td>
                                        <td>77</td>
                                        <td>70</td>
                                    </tr>
                                    <tr>
                                        <td>vtb.ru</td>
                                        <td>29</td>
                                        <td>43</td>
                                    </tr>
                                    <tr>
                                        <td>alfabank.ru</td>
                                        <td>51</td>
                                        <td>68</td>
                                    </tr>
                                    <tr>
                                        <td>tinkoff.ru</td>
                                        <td>79</td>
                                        <td>42</td>
                                    </tr>
                                    <tr>
                                        <td>raiffeisen.ru</td>
                                        <td>25</td>
                                        <td>41</td>
                                    </tr>
                                    <tr>
                                        <td>open.ru</td>
                                        <td>27</td>
                                        <td>39</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default Analysis;
